import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Permissions, Roles } from '@enums';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { BreadcrumbService, BreakpointService, SessionService } from '@services';
import { BaseComponent } from '../../../../base.component';
import { NavToolbarService } from '../../../helpers/navtoolbar.service';
import { ShareModalComponent } from '../../share-modal/share-modal.component';
import { SupportModalComponent } from '../../support-modal/support-modal.component';

@UntilDestroy()
@Component({
  selector: 'app-share-and-donate',
  templateUrl: './share-and-donate.component.html',
  styleUrls: ['./share-and-donate.component.scss'],
})
export class ShareAndDonateComponent extends BaseComponent implements OnInit {
  public isDonateAvailable = false;
  public canAccessSettings = false;
  public pageTitle: string;

  constructor(
    protected override sessionService: SessionService,
    protected override breakpointService: BreakpointService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private breadcrumbService: BreadcrumbService,
    private navToolbarService: NavToolbarService,
    private router: Router,
  ) {
    super(sessionService, breakpointService);
    this.checkDesktop();
    this.isDonateAvailable = <boolean>this.sessionService.getSiteConfigurations().donation?.enabled;
    this.breadcrumbService.breadcrumbs$.pipe(untilDestroyed(this)).subscribe({
      next: (res) => (this.pageTitle = res[res.length - 1]?.instance),
    });
  }

  ngOnInit(): void {
    this.getUserData();
  }

  loadData(): void {
    const hostRoles = [
      Permissions.ManageUsers,
      Permissions.ManageSettings,
      Permissions.ImportExport,
      Permissions.ManageSettingsGeneral,
      Permissions.ManageSettingsSurveys,
      Permissions.ManageSettingsCategories,
      Permissions.ManageSettingsWebhooks,
    ];
    this.canAccessSettings =
      this.user.role === Roles.Admin || hostRoles.some((r) => this.user.permissions?.includes(r));
  }

  public openShare() {
    this.dialog.open(ShareModalComponent, {
      width: '100%',
      maxWidth: 564,
      panelClass: 'modal',
      data: {
        title: this.translate.instant(this.pageTitle),
        description: this.translate.instant(this.pageTitle),
        label: this.translate.instant('share.share_deployment'),
      },
    });
  }

  public openAboutModal(): void {
    this.dialog.open(SupportModalComponent, {
      width: '100%',
      maxWidth: 768,
      panelClass: ['modal', 'support-modal'],
    });
  }

  public openSettings(): void {
    this.navToolbarService.toggleBurgerMenu(false);
    this.router.navigate(['/settings']);
  }
}
